import JiriPage from '@/views/jiri/JiriPage'

export default function JiriScreen() {
  return <JiriPage />
}
